import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class PhoneValidatorService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/pickUtils');

  parsePhoneNumber(number: string, country: string) {
    const searchParams = new URLSearchParams({ number, country });
    return this.api.getJSON(`${PhoneValidatorService.baseUrl}/phoneValidator?${searchParams.toString()}`);
  }

  splitPhoneNumber(number: string) {
    const searchParams = new URLSearchParams({ number });
    return this.api.getJSON(`${PhoneValidatorService.baseUrl}/splitPhone?${searchParams.toString()}`);
  }
}
